import { PaymentInfo } from './utils/useCartPayment';

import { PayWithCreditCardRequest, PayWithDebitCardRequest } from 'common/types/CheckoutRequest';

export type OrderSteps = 'summary' | 'payment' | 'shipping' | 'review' | 'success';

export interface CartInfoState {
    shipToHome?: boolean;
    shippingMethodId: string;
    shippingToAddressId?: string;
    paymentMethodId?: PaymentInfo;
    newCreditCard?: PayWithCreditCardRequest;
    newDebitCard?: PayWithDebitCardRequest;
    billingAddressId?: string;
    setPaymentMethodAsDefault: boolean;
    setShippingAddressAsDefault?: boolean;

    // CLO data for linking purposes
    cardToLinkWithClo?: number; // for existing cards
    linkNewCardWithClo?: boolean; // for new cards
}

export const initialState: CartInfoState = {
    shipToHome: undefined,
    shippingMethodId: '',
    paymentMethodId: undefined,
    shippingToAddressId: undefined,
    billingAddressId: undefined,
    setPaymentMethodAsDefault: false,
    setShippingAddressAsDefault: false,
};
